module.exports = __webpack_public_path__ + "static/media/kuva.918a96cb.png";